import React, { useMemo } from 'react';

import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import dayjs from 'dayjs';

import { FormCompletionRecord } from '@vyce/core/src/types';

import { signatureBase64ToDataUrl } from '../utils/signature';

const formatCompletedAt = (iso: string) => {
  if (!iso) {
    return '—';
  }
  const d = dayjs(iso);
  return d.isValid() ? d.format('DD/MM/YYYY HH:mm') : '—';
};

const CompletionSignatureCell: React.FC<{ signatureBase64: string | null }> = ({ signatureBase64 }) => {
  const dataUrl = useMemo(() => {
    if (!signatureBase64) {
      return null;
    }
    return signatureBase64ToDataUrl(signatureBase64);
  }, [signatureBase64]);

  if (!dataUrl) {
    return <>—</>;
  }

  return (
    <Box className="form-summary-completion-signature-cell" component="span" display="inline-block">
      <img className="form-summary-completion-signature-img" src={dataUrl} alt="" />
    </Box>
  );
};

export const FormSummaryCompletionTable: React.FC<{
  records: FormCompletionRecord[];
  showSignatureColumn: boolean;
}> = ({ records, showSignatureColumn }) => {
  if (!records.length) {
    return null;
  }

  return (
    <Paper variant="outlined" style={{ padding: 24, width: '100%', marginTop: 8 }}>
      <Typography variant="h6" component="h2" gutterBottom style={{ marginBottom: 16 }}>
        Respondents
      </Typography>
      <TableContainer>
        <Table size="small" className="form-summary-completion-table">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell className="form-summary-screen-only">NI number</TableCell>
              <TableCell>Job title</TableCell>
              <TableCell>Date completed</TableCell>
              {showSignatureColumn ? <TableCell>Signature</TableCell> : null}
            </TableRow>
          </TableHead>

          <TableBody>
            {records.map(row => (
              <TableRow key={row.responseId}>
                <TableCell>{row.name}</TableCell>
                <TableCell className="form-summary-screen-only">{row.niNumber || '—'}</TableCell>
                <TableCell>{row.jobTitle || '—'}</TableCell>
                <TableCell>{formatCompletedAt(row.completedAt)}</TableCell>
                {showSignatureColumn ? (
                  <TableCell>
                    <CompletionSignatureCell signatureBase64={row.signatureBase64} />
                  </TableCell>
                ) : null}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
